import { useMemo } from 'react'
import { useTbViewStore, useProjectStore } from '@vt/hooks'

const userConfig = {
  default: {
    roleSlug: 'zdy_jianchayuan',
  },
}

const getOrgIds = (orgTree, orgId) => {
  if (!orgId) return []
  const search = (list) => {
    for (let i = 0; i < list.length; i++) {
      const node = list[i]
      if (node.id === orgId) {
        return node
      }

      if (node.children) {
        const result = search(node.children)
        if (result) return result
      }
    }
    return null
  }

  const org = search(orgTree)

  const orgIds = []
  const loop = (node) => {
    if (!node) return
    orgIds.push(node.id)
    node.children?.forEach(loop)
  }

  loop(org)

  return orgIds
}

const transformRoleOrgConfig = (custom, userInfo) => {
  let checkSameOrg = false

  if (custom.sameOrg) {
    checkSameOrg = true
    const { except } = custom.sameOrg
    if (except) {
      const roles = Object.keys(except)

      const { roleSlug, orgSlug } = userInfo
      const result = roles.filter((key) =>
        except[key].some((cfg) => {
          if (cfg.roleSlug && cfg.roleSlug !== roleSlug) return false
          if (cfg.orgSlug && cfg.orgSlug !== orgSlug) return false
          return true
        })
      )
      if (result.length) {
        custom.roleSlug = result
        checkSameOrg = false
      }
    }

    delete custom.sameOrg
  }

  return checkSameOrg
}

export const useUserListFilter = () => {
  const detailConfig = useTbViewStore((state) => state.detailConfig)
  const userInfo = useProjectStore((state) => state.userInfo)

  const userChecker = useMemo(() => {
    const common = { ...userConfig.default }
    const custom = { ...detailConfig?.userConfig }

    const config = common
    const checkSameOrg = transformRoleOrgConfig(custom, userInfo)
    Object.assign(config, custom)

    return (list, orgs) => {
      const checkConfig = { ...config }
      if (checkSameOrg) {
        const orgIds = getOrgIds(orgs, userInfo?.orgId)
        checkConfig.orgId = orgIds
      }
      const keys = Object.keys(checkConfig)
      return list.filter((user) =>
        keys.every((key) => {
          if (Array.isArray(checkConfig[key])) {
            return checkConfig[key].includes(user[key])
          }
          return user[key] === checkConfig[key]
        })
      )
    }
  }, [detailConfig, userInfo])

  return userChecker
}

export const useCustomizedCheck = () => {
  const detailConfig = useTbViewStore((state) => state.detailConfig)

  return detailConfig?.customConfig || {}
}
